import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import './firebase'; // guarantee the portal (default) app is initialised first

import { isLocal } from './config';
import { resolve, ANALYTICS_ENABLED } from './firebase-projects';

// live: prmassist1.  sandbox: prm-sandbox-env.  sgs: prmassist-sgs.
const secondaryConfig = resolve('secondary');

let app;
let firestore;
let storage;

if (isLocal) {
  // Employee/task Firestore lives on prmassist1. The backend Admin SDK writes
  // there, and /customtoken mints prmassist1 tokens with iata claims for reads.
  // Reusing the portal app broke both: wrong project + rules denied queries.
  try {
    firebase.initializeApp(secondaryConfig, "secondary");
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

  app = initializeApp(secondaryConfig, "secondary");
  firestore = getFirestore(app);
  storage = getStorage(app);

  connectAuthEmulator(getAuth(app), 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);

  console.log(`Emulator mode — secondary app (${secondaryConfig.projectId}) connected to Firebase emulators`);
} else {
  try {
    firebase.initializeApp(secondaryConfig, "secondary");
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

  app = initializeApp(secondaryConfig, "secondary");
  firestore = initializeFirestore(app, {
    localCache: memoryLocalCache(),
  });
  storage = getStorage(app);

  if (ANALYTICS_ENABLED) {
    try {
      getAnalytics(app);
    } catch (e) {
      if (!/already exists/.test(e.message)) throw e;
    }
  }
}

const fire = firebase;
export default fire;
export { app, firestore, storage };
